import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getVideoConversionTemplatesByEntityId = createAsyncThunk(
  "videoConversionTemplate/getVideoConversionTemplate",
  async (payload) => {
    try {
      const response = await magnifiAPI.getVideoConversionTemplatesByEntityId(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const createVideoConversionTemplate = createAsyncThunk(
  "videoConversionTemplate/createVideoConversionTemplate",
  async (payload) => {
    try {
      const response = await magnifiAPI.createVideoConversionTemplate(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const editVideoConversionTemplate = createAsyncThunk(
  "videoConversionTemplate/editVideoConversionTemplate",
  async (payload) => {
    try {
      const response = await magnifiAPI.editVideoConversionTemplate(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const deleteVideoConversionTemplate = createAsyncThunk(
  "videoConversionTemplate/deleteVideoConversionTemplate",
  async (payload) => {
    try {
      const response = await magnifiAPI.deleteVideoConversionTemplate(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);
